import { inject } from '@angular/core';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import type { ApolloClientOptions, NormalizedCacheObject } from '@apollo/client/core';
import { environment } from '../environments/environment';

export function apolloOptionsFactory(): ApolloClientOptions<NormalizedCacheObject> {
  const httpLink = inject(HttpLink);

  const uri = window['ebbApi']
    ? `${window['ebbApi']}/graphql`
    : `https://${environment.devBaseUrl}/api/graphql`;

  return {
    link: httpLink.create({
      uri,
      withCredentials: true,
    }),
    cache: new InMemoryCache(),
  };
}

export const APOLLO_PROVIDERS = [
  provideApollo(apolloOptionsFactory),
];
